import { instanceToPlain, plainToInstance } from 'class-transformer'
import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
} from 'react'
import { UserDetails } from '../types/schemas/abc'

type UserProviderType = {
  userDetails: UserDetails | undefined
  storeUserDetails: (userDetails: UserDetails, accessToken: string) => void
  clearUserDetails: () => void
}

const defaultUser: UserProviderType = {
  userDetails: undefined,
  storeUserDetails: (_: UserDetails) => {},
  clearUserDetails: () => {},
}

const UserContext = createContext<UserProviderType>(defaultUser)

function getUserDetailsOrUndefined(): UserDetails | undefined {
  const storedUserDetails = localStorage.getItem('userDetails')
  if (storedUserDetails) {
    return plainToInstance(UserDetails, JSON.parse(storedUserDetails))
  }
  return undefined
}

export const UserProvider = ({ children }: { children: ReactNode }) => {

  const [userDetails, setUserDetails] = useState<UserDetails | undefined>(
    getUserDetailsOrUndefined()
  )

  const storeUserDetails = (details: UserDetails, accessToken: string) => {
    setUserDetails(details)
    localStorage.setItem('userDetails', JSON.stringify(instanceToPlain(details)))
    localStorage.setItem('accessToken', accessToken)
  }

  const clearUserDetails = () => {
    setUserDetails(undefined)
    localStorage.removeItem('userDetails')
    localStorage.removeItem('accessToken')
  }

  return (
    <UserContext.Provider value={{ userDetails, storeUserDetails, clearUserDetails }}>
      {children}
    </UserContext.Provider>
  )
}

export const useUser = () => {
  return useContext(UserContext)
}
